import React, { InputHTMLAttributes } from 'react'
import { ProductSize } from '../ProductView/ProductView'
import { ProductVariant } from '@commerce/types/product'
import cn from 'clsx'
import s from './SizeSelector.module.css'

export type SelectOption = {
  label: string
  value: string | number
} & Partial<ProductVariant>

export interface SelectProps extends InputHTMLAttributes<HTMLSelectElement> {
  label?: string
  selected?: SelectOption | undefined | null
  className?: string
  options?: SelectOption[]
  onClick?: () => void
  onSelectOption: (selectedSizeId: ProductSize['value']) => void
  variantTitle?: string
  hasSizeGuide?: boolean
}

const INITIAL_OPTIONS: SelectProps['options'] = [
  {
    label: 'Please select',
    value: 0,
  },
]

const Select: React.FC<SelectProps> = ({
  selected,
  className,
  options = INITIAL_OPTIONS,
  onClick,
  variantTitle = 'Label',
  onSelectOption,
  hasSizeGuide,
}) => {
  return (
    <div className={cn('flex flex-col w-full', s.root, className)}>
      <div className={s.label}>
        <label>
          {variantTitle && <span>{variantTitle?.toUpperCase()}</span>}
          <span>
            {selected ? selected.label : `*Please select a ${variantTitle}`}
          </span>
        </label>
        {variantTitle === 'gift card value' || !hasSizeGuide ? (
          ''
        ) : (
          <button onClick={onClick}>
            <div className={s.label__icon}>
              <img
                src="/icons/sizeguide.svg"
                alt="Side Guide"
                width={15}
                height={15}
              />
            </div>
            <span className={s.label__title}>Size guide</span>
          </button>
        )}
      </div>
      {/* leaving this in case we want to bring back dropdown functionality */}
      {/* <select onChange={onChange} value={selected?.value}>
        {[...INITIAL_OPTIONS, ...options].map((option, index) => (
          <option value={option.value} key={index}>
            {option?.label}
          </option>
        ))}
      </select> */}
      {options.length && (
        <div className="flex gap-2 flex-wrap">
          {options.map((option, index) => {
            const isSelected = option?.value === selected?.value
            return (
              <button
                key={`option-${index}`}
                className={cn(
                  `${s.option}`,
                  isSelected && s.selected,
                  !option.quantityAvailable && s.unavailable
                )}
                onClick={() => onSelectOption(option.value)}
              >
                {option.label}
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default Select
